var map = {
	"./596f61ee-7149-43ac-ba4e-efb90ee3bd47.png": 44621,
	"./7accc260-ab82-4c51-a959-e6736284c45a.png": 71481,
	"./9be7083e-be8b-4608-96d0-a526445b4667.png": 86957,
	"./c6e4b1bf-843e-4859-bc85-c3b764f507e6.png": 21631,
	"./carbon.png": 10717,
	"./carbon_v2.png": 57250,
	"./plastic.png": 47552,
	"./plastic_v2.png": 8357,
	"./trees.png": 78427,
	"./trees_v2.png": 56664
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6757;